import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class DrugListUpdateRequestType extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined
    this._action = init.action
    this._created_at = init.created_at
    this._updated_at = init.updated_at
    this._date = init.date
    this._drug_list_name = init.drug_list_name
    this._employee_id = init.employee_id
    this._form_attachment = init.form_attachment
    this._gpi = init.gpi
    this._id = init.id
    this._ndc = init.ndc
    this._medication_name = init.medication_name
  }

  static shape = {
    id: PropTypes.string,
    employee_id: PropTypes.string.isRequired,
    action: PropTypes.string,
    created_at: PropTypes.number,
    updated_at: PropTypes.number,
    date: PropTypes.string,
    drug_list_name: PropTypes.string,
    form_attachment: PropTypes.string,
    gpi: PropTypes.string,
    ndc: PropTypes.string,
    medication_name: PropTypes.string
  }

  get employee_id() {
    return this._employee_id
  }

  get id() {
    return this._id
  }

  get action() {
    return this._action
  }

  get created_at() {
    return this._created_at
  }

  get updated_at() {
    return this._updated_at
  }

  get date() {
    return this._date
  }

  get drug_list_name() {
    return this._drug_list_name
  }

  get form_attachment() {
    return this._form_attachment
  }

  get gpi() {
    return this._gpi
  }

  get medication_name() {
    return this._medication_name
  }

  get ndc() {
    return this._ndc
  }
}

export default DrugListUpdateRequestType
